import { ModalHandler } from "./ModalHandler";

export class ConfigManager{

    modalHandler:ModalHandler
    maxMessageLength:number | undefined
    constructor(){
        this.modalHandler = new ModalHandler()
    }

    setmaxMessageLength(value:number){
        this.maxMessageLength = value
       const input = document.getElementById('message-input') as HTMLInputElement
       if(input){
        input.maxLength = value
       }
    }
}